import React, {Component} from 'react'

import {Route, NavLink, Redirect} from 'react-router-dom'

export default class navMenu extends Component {
    constructor(props) {
        super(props)

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    render() {
        return (
            <div className="navMenu_tab_block">
                <ul>
                    <li className="tab">
                        <NavLink to={`/investor/dashboard`} activeClassName="tab_link-selected">{this.translation['Dashboard']}</NavLink>
                    </li>
                    <li className="tab">
                        <NavLink to={`/investor/depository`} activeClassName="tab_link-selected">{this.translation['Depository']}</NavLink>
                    </li>
                    {/*<li className="tab">*/}
                        {/*<NavLink to={`/investor/bonus`} activeClassName="tab_link-selected">{this.translation['Bonus']}</NavLink>*/}
                    {/*</li>*/}
                    <li className="tab">
                        <NavLink to={`/investor/wallet`} activeClassName="tab_link-selected">{this.translation['Wallet']}</NavLink>
                    </li>
                    <li className="tab">
                        <NavLink to={`/investor/history`} activeClassName="tab_link-selected">{this.translation['History']}</NavLink>
                    </li>
                    {/*<li className="tab">*/}
                        {/*<NavLink to={`/investor/help`} activeClassName="tab_link-selected">{this.translation['FAQ']}</NavLink>*/}
                    {/*</li>*/}
                </ul>
            </div>
        )
    }

}
